module.exports = __webpack_public_path__ + "static/esgr-photo-754364bc7552bbbcb0eef5fe35c92883.jpg";